module.exports = __webpack_public_path__ + "img/9-filters-04.8d47161b.svg";